import { render, staticRenderFns } from "./Funds.vue?vue&type=template&id=7d003d6d&"
import script from "./Funds.vue?vue&type=script&lang=ts&"
export * from "./Funds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports